import React from "react";
import { Box, styled } from "@material-ui/core";
import ConnectedAdressForm from "components/localOffer/ConnectedAddressForm";
import InformationDrawer from "components/design-system/molecules/InformationDrawer";
import { BodyLarge, H4 } from "components/design-system/atoms/Typography";
import { getClientLocalCatalogs } from "components/localOfferEligibility/LocalOfferEligibility";
import Caption from "components/design-system/atoms/Typography/Caption";
import Card from "components/design-system/atoms/Card";
import Ah from "components/localOffer/assets/smallAh.svg";
import Button from "components/design-system/atoms/Button";
import theme from "theme";
import LocalOfferTile from "components/localOffer/LocalOfferTile";

const UnderlinedText = styled("span")({
  textDecoration: "underline",
  textDecorationColor: theme.palette.yellow200,
  textDecorationThickness: theme.spacing(1),
  textDecorationSkipInk: "none",
  textUnderlineOffset: "-7px", //specific translation to place line behind text
});

const DrawerContent = ({ addCatalogsToRefinementList, displayNonEligibleContent, handleClose }) => {
  return (
    <Box py={1}>
      <LocalOfferTile
        addressAutocompleteId="modal-autocomplete"
        addCatalogsToRefinementList={() => {
          if (getClientLocalCatalogs()?.length > 0) {
            addCatalogsToRefinementList();
            handleClose();
          } else {
            displayNonEligibleContent();
          }
        }}
      />
    </Box>
  );
};

const DrawerContentNonEligible = ({ addCatalogsToRefinementList, setDisplayNonEligibleContent, handleClose }) => (
  <Box py={1}>
    <Box mb={1} onClick={() => setDisplayNonEligibleContent(false)}>
      <ConnectedAdressForm
        id={`mobile-modal-local-offer-non-eligible`}
        autoFocusField={false}
        addCatalogsToRefinementList={() => undefined}
        disabled
      >
        <></>
      </ConnectedAdressForm>
    </Box>
    <Box mb={2} pl={3}>
      <Caption color="grey700.main">Aucun appareil disponible</Caption>
    </Box>
    <Card variant="flat" p={3} textAlign="center">
      <Box mr={1} mb="-17px" textAlign="end">
        <Ah />
      </Box>
      <Box mb={3}>
        <H4 color="secondary.main">La livraison locale n’est pas encore disponible chez vous.</H4>
      </Box>
      <Box mb={3}>
        <BodyLarge>
          Mais pas de panique, voilà une liste d’appareils livrés <UnderlinedText>entre 3 et 7 jours.</UnderlinedText>
        </BodyLarge>
      </Box>
      <Button
        fullWidth
        dimension="jumbo"
        onClick={() => {
          addCatalogsToRefinementList();
          handleClose();
          setDisplayNonEligibleContent(false);
        }}
      >
        Voir les appareils
      </Button>
    </Card>
  </Box>
);

export default function LocalOfferMobileModal({ addCatalogsToRefinementList, preventOpening = false, children }) {
  const [displayNonEligibleContent, setDisplayNonEligibleContent] = React.useState(false);
  return (
    <InformationDrawer
      preventOpening={preventOpening}
      anchor="bottom"
      width="100%"
      backgroundColor={theme.palette.green}
      button={children}
    >
      {(props) =>
        displayNonEligibleContent ? (
          <DrawerContentNonEligible
            handleClose={props.handleClose}
            addCatalogsToRefinementList={addCatalogsToRefinementList}
            setDisplayNonEligibleContent={setDisplayNonEligibleContent}
          />
        ) : (
          <DrawerContent
            handleClose={props.handleClose}
            displayNonEligibleContent={() => setDisplayNonEligibleContent(true)}
            addCatalogsToRefinementList={addCatalogsToRefinementList}
          />
        )
      }
    </InformationDrawer>
  );
}
